// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1Gar5","selects":"Documents_selects__1Xjfq"};